// Image styles
export const IMAGE_STYLES = {
    vivid: { title: 'Vivid', value: 'vivid' },
    natural: { title: 'Natural', value: 'natural' },
};
